import React from 'react';
import { Radio } from 'antd';
import { COUNT, PERCENTAGE } from '@utils/metrics';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

const CountPercentageTabs = ({ onToggle, value }) => {
  const memoizedHandleToggle = React.useCallback(
    (e) => {
      onToggle(e.target.value);
    },
    [onToggle],
  );
  return (
    <RadioGroup value={value} onChange={memoizedHandleToggle}>
      <RadioButton id="trends-dimensions-count" value={COUNT}>
        #
      </RadioButton>
      <RadioButton id="trends-dimensions-percent" value={PERCENTAGE}>
        %
      </RadioButton>
    </RadioGroup>
  );
};

export default CountPercentageTabs;
